import { useEffect, useState } from "react";
import { useSearchParams, Link , useParams} from "react-router-dom";
import { Col, Row, Table, Button, Grid } from "antd";
import { StyledCard } from './style';
import { MyText } from "../../components";
import {LeftOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import { ButtonContainer } from "../MaterialsDetail/style";
import { MyButton } from "../../components";
import html2pdf from "html2pdf.js";
import { LogoIcon } from "../../assets";
import ReactDOM from "react-dom";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import { useDispatch, useSelector } from "react-redux";
import { fetchListRequestAction } from "../../utils";

const isMobile = window.innerWidth < 768;

export const ResultsConsultationPage = () => {
  const {t} = useTranslation("common")

  const [searchParams, setSearchParams] = useSearchParams();
  const [kindergartens, setKindergartens] = useState<any[]>([]);

  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  // const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const segmentedParams: any = searchParams.get('type');
  const dispatch = useDispatch();
  const listRequestState = useSelector((state: any) => state.materials?.listRequest ?? { data: null, loading: false });
  const loading = listRequestState.loading;
  const {testId} = useParams();
  const {type} = useParams();
  const embeddedNavigate = useEmbeddedNavigate();

  const navigate = useNavigate();


  // useEffect(() => {
  //       const fetchData = async () => {
  //         try {
  //           const response = await fetchListRequest();
  //           if (response && response.items) {
  //             setKindergartens(response.items);
  //             const selectedSurveyItem = response.items.find(item => item.id == testId)
  //           if (selectedSurveyItem) {
  //             setSelectedSurvey(selectedSurveyItem);  
  //           }
  //           } else {
  //             setKindergartens([]);
  //           }
  //         } catch (error) {
  //           console.error("Ошибка при получении данных:", error);
  //         } finally {
  //           setLoading(false);
  //         }
  //       };
    
  //       fetchData();

  //     }, []);

  useEffect(() => {
    dispatch(fetchListRequestAction());
  }, []);

  useEffect(() => {
    if (!listRequestState.success || !listRequestState.data) return;
    const items = listRequestState.data?.items || [];
    setKindergartens(items);
    const selectedSurveyItem = items.find(item => item.id == testId);
    if (selectedSurveyItem) {
      setSelectedSurvey(selectedSurveyItem);
    }
  }, [listRequestState.success, listRequestState.data]);

      const handleGoBack = () => {
          embeddedNavigate(`/my-consultations`);
      };

    const handleOpenPDF = () => {
      const exportContent = document.getElementById("export-content");
  
      if ( exportContent) {
          const tempContainer = document.createElement("div");
          tempContainer.style.padding = "5px";
          tempContainer.style.fontFamily = "Nunito";
          tempContainer.style.fontSize = "16px";
          tempContainer.style.lineHeight = "32px";
  

          const logoContainer = document.createElement("div");
          logoContainer.style.display = "flex";
          logoContainer.style.marginBottom = "12px";
  
          ReactDOM.render(<LogoIcon style={{ width: 263, height: 52 }} />, logoContainer);

          const headerDiv = document.createElement("div");
          headerDiv.innerHTML = `
          
              <hr style="border: none; border-top: 1px solid #E0E0E0; margin-bottom: 16px;">

              <div style="display: flex; justify-content: space-between; font-size: 16px; font-weight: 600; margin-bottom: 8px">
                  <span><strong>${testType == 2 ? t("consultationAnswer") : testType == 1 ? t("consultationAnswer") : t("consultationAnswer")} SabiDamu</strong></span>
              </div>
              
          `;

          tempContainer.appendChild(logoContainer);

          tempContainer.appendChild(headerDiv);
  
          
          tempContainer.appendChild(exportContent.cloneNode(true));
  
          html2pdf()
              .from(tempContainer)
              .set({
                  margin: 16,
                  filename: "document.pdf",
                  image: { type: "jpeg", quality: 0.98 },
                  html2canvas: { scale: 2 },
                  jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
                  pagebreak: { mode: ["avoid-all", "css", "legacy"] }
              })
              .save();
      } else {
          console.warn("Элементы pdf-content или export-content не найдены.");
      }
  };


      const testType = kindergartens.find(item => item.test_id == testId)?.type;

  return (
    <Row justify='center'>
      <Col span={20}>
          
          <Row align="middle" style={{marginBottom: 26, height:screens.xs ? 'auto' : '60px'}}>
          {screens.xs ? (
                                  <>
                                    <Col span={3}>
                                      <ButtonContainer onClick={handleGoBack}>
                                        <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                                      </ButtonContainer>
                                    </Col>
                                    <Col span={21}>
                                      <MyText
                                        color="rgba(19, 15, 38, 1)"
                                        size={26}
                                        weight={800}
                                        style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                      >
                                        {testType == 2 ? t("consultationAnswer") : testType == 1 ? t("consultationAnswer") : t("consultationAnswer")}
                                      </MyText>
                                    </Col>
                                  </>
                                ) : (
                                  <>
                                    <ButtonContainer onClick={handleGoBack}>
                                      <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                                    </ButtonContainer>
                                    <MyText
                                      color="rgba(19, 15, 38, 1)"
                                      size={32}
                                      weight={800}
                                      style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                    >
                                      {testType == 2 ? t("consultationAnswer") : testType == 1 ? t("consultationAnswer") : t("consultationAnswer")}
                                    </MyText>
                                  </>
                                )}
        </Row>

        <Row gutter={[24,24]}>

            <Col span={screens.xs ? 24 : 24}>
            <StyledCard>
              <Row style={{ padding: 32 }} align="middle" justify="space-between">
                <Col span={18}>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={20}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', marginLeft:screens.xs ? 0 : 32 }}
                  >
                    {t("consultationAnswer")}
                  </MyText>
                </Col>
                <Col span={screens.xs ? 24 : 3} style={{marginTop: screens.xs ? 16 : 0, marginBottom: screens.xs ? 16 : 0, borderRadius: 10, background:'rgba(231, 250, 255, 1)', border: 'none', cursor: 'pointer',}} onClick={handleOpenPDF}>
                {/* <Button style={{borderRadius: 10, height: 38, background:'rgba(231, 250, 255, 1)', border: 'none'}} onClick={handleOpenPDF}> */}
                <Row align="middle" justify="center" style={{height: 40}}>

                <MyText color='rgba(0, 141, 210, 1)' weight={700} style={{ fontFamily: 'Nunito' }} >{t("downloadResult")}</MyText>
                </Row>
                  {/* </Button> */}
                </Col>

                <Col span={24}>
                
                <Row>

                <Col style={{ maxWidth: '100%', wordWrap: 'break-word', padding: screens.xs ? 0 : 32 }}>
                  {selectedSurvey?.answer ? (
                    <MyText
                      color="rgba(19, 15, 38, 1)"
                      size={24}
                      weight={400}
                      style={{ fontFamily: 'Nunito', lineHeight: '32px', textAlign: 'justify' }}
                    >
                      <div
                        id="export-content"
                        style={{
                          fontFamily: 'Nunito',
                          lineHeight: '16px',
                          fontSize: '16px',
                        }}
                        dangerouslySetInnerHTML={{
                          __html: selectedSurvey?.answer?.text,
                        }}
                      />
                    </MyText>
                  ) : (
                    <MyText
                      color="rgba(19, 15, 38, 1)"
                      size={16}
                      weight={400}
                      style={{ fontFamily: 'Nunito', textAlign: 'center' }}
                    >
                      {t("noData")}
                    </MyText>
                  )}
                </Col>
                </Row>
                </Col>

                <Col span={24}>
                <Row align="middle" justify="center" style={{ marginTop: '38px', gap: '25px' }}>
                        
                        <MyButton
                          type="default"
                          style={{ padding: '28px 28px', background: 'rgba(229, 233, 242, 1)' }}
                          onClick={handleGoBack}
                        >
                          <MyText
                            weight={600}
                            size={18}
                            style={{ lineHeight: '24px' }}
                          >
                            {t("returnToList")}
                          </MyText>
                        </MyButton>
                      </Row>
                </Col>
              </Row>
            </StyledCard>
          </Col>   
          </Row>
      </Col>
    </Row>
  );
};
